exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/core-js/modules/_wks-ext.js
// module id = 240
// module chunks = 0